import * as React from 'react';
import fcfmLogo from '../../assets/images/fcfm.png';
import { Stack, IStackStyles } from '@fluentui/react';
import { SignOutButton } from '../Login/SignOutButton';
import { useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';

const stackStyles: IStackStyles = {
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#333333', // Light gray background
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
  },
};

const Layout: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  return (
    <header>
      <Stack horizontal styles={stackStyles}>
        {/* Left: Logo clickable */}
        <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
          <img
            src={fcfmLogo}
            className="imagefcfm"
            alt="FCFM Logo"
            style={{ height: '50px', cursor: 'pointer' }}
            onClick={() => navigate('/')}
          />
        </Stack>

        {/* Right: Sign Out Button */}
        {isAuthenticated && <SignOutButton />}
      </Stack>
    </header>
  );
};

export default Layout;
